import { MessageService } from '../services/message.service';
import { AppInjector } from "../app.injector";
import { T as Trad } from '../tools/Traductions';

/**
 * Repr�sente la classe de base d'un composant
 */
export class BaseComponent {
    public T: (clef, ...params) => string = Trad;
    protected messageService: MessageService

    public get componentName() { return this.constructor.name; }

    /**
     * Constructeur
     */
    constructor() {
        // R�cup�re le service de message
        this.messageService = AppInjector.get(MessageService);
    }
}